/**
 * Happy Hive FAQs Interactivity
 * Handles exclusive accordions, category pill switching, and instant live search.
 */

(function () {
  function initAccordion(container) {
    if (!container) return;

    const items = container.querySelectorAll('.hh-accordion-item, .hh-page-accordion-item');

    items.forEach((item) => {
      const trigger = item.querySelector('.hh-accordion-trigger, .hh-page-accordion-trigger');
      const body = item.querySelector('.hh-accordion-body, .hh-page-accordion-body');
      if (!trigger || !body) return;

      trigger.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        // Exclusive accordion behavior: Close all other open items in the same container / section
        const parentSection = item.closest('.hh-accordion-group') || item.closest('.hh-section-accordions') || container;
        parentSection.querySelectorAll('.hh-accordion-item.is-open, .hh-page-accordion-item.is-open').forEach((openItem) => {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            const openTrigger = openItem.querySelector('.hh-accordion-trigger, .hh-page-accordion-trigger');
            const openBody = openItem.querySelector('.hh-accordion-body, .hh-page-accordion-body');
            if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
            if (openBody) openBody.style.maxHeight = null;
          }
        });

        // Toggle clicked item
        if (isOpen) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  function initFaqsPage() {
    const pageContainer = document.querySelector('.hh-faqs-page');
    if (!pageContainer) return;

    // Category pills switching
    const pills = pageContainer.querySelectorAll('.hh-category-pill');
    const panels = pageContainer.querySelectorAll('.hh-faq-section-panel');
    const searchInput = pageContainer.querySelector('.hh-faqs-search-input');
    const clearBtn = pageContainer.querySelector('.hh-faqs-search-clear');
    const searchStats = pageContainer.querySelector('.hh-search-stats');
    const noResults = pageContainer.querySelector('.hh-faqs-no-results');

    pills.forEach((pill) => {
      pill.addEventListener('click', function () {
        // If there's active search, clear search first
        if (searchInput && searchInput.value.trim() !== '') {
          searchInput.value = '';
          if (clearBtn) clearBtn.classList.remove('is-visible');
          if (searchStats) searchStats.classList.remove('is-visible');
          resetSearchFilter();
        }

        pills.forEach((p) => p.classList.remove('is-active'));
        this.classList.add('is-active');

        const targetCategory = this.getAttribute('data-category');

        panels.forEach((panel) => {
          const panelCategory = panel.getAttribute('data-section-category');
          if (targetCategory === 'all' || panelCategory === targetCategory) {
            panel.classList.add('is-active');
          } else {
            panel.classList.remove('is-active');
          }
        });
      });
    });

    // Reset search filter function
    function resetSearchFilter() {
      const activePill = pageContainer.querySelector('.hh-category-pill.is-active');
      const activeCategory = activePill ? activePill.getAttribute('data-category') : 'all';

      panels.forEach((panel) => {
        const panelCategory = panel.getAttribute('data-section-category');
        if (activeCategory === 'all' || panelCategory === activeCategory) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }

        const items = panel.querySelectorAll('.hh-page-accordion-item');
        items.forEach((item) => {
          item.style.display = '';
        });
      });

      if (noResults) noResults.classList.remove('is-visible');
    }

    // Live Instant Search Filter
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        const query = this.value.trim().toLowerCase();

        if (clearBtn) {
          if (query.length > 0) {
            clearBtn.classList.add('is-visible');
          } else {
            clearBtn.classList.remove('is-visible');
          }
        }

        if (query.length === 0) {
          if (searchStats) searchStats.classList.remove('is-visible');
          resetSearchFilter();
          return;
        }

        let totalMatches = 0;

        // When searching, make all panels visible so results can be found in any section
        panels.forEach((panel) => {
          let panelMatches = 0;
          const items = panel.querySelectorAll('.hh-page-accordion-item');

          items.forEach((item) => {
            const questionText = item.querySelector('.hh-page-accordion-trigger')?.textContent?.toLowerCase() || '';
            const answerText = item.querySelector('.hh-page-accordion-content')?.textContent?.toLowerCase() || '';

            if (questionText.includes(query) || answerText.includes(query)) {
              item.style.display = '';
              panelMatches++;
              totalMatches++;
            } else {
              item.style.display = 'none';
            }
          });

          if (panelMatches > 0) {
            panel.classList.add('is-active');
          } else {
            panel.classList.remove('is-active');
          }
        });

        if (searchStats) {
          searchStats.textContent = totalMatches === 1
            ? `Found 1 question matching "${query}"`
            : `Found ${totalMatches} questions matching "${query}"`;
          searchStats.classList.add('is-visible');
        }

        if (noResults) {
          if (totalMatches === 0) {
            noResults.classList.add('is-visible');
          } else {
            noResults.classList.remove('is-visible');
          }
        }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          searchInput.value = '';
          clearBtn.classList.remove('is-visible');
          if (searchStats) searchStats.classList.remove('is-visible');
          resetSearchFilter();
          searchInput.focus();
        });
      }
    }
  }

  // Initialize on DOMContentLoaded and Shopify Theme Customizer events
  function initAll() {
    document.querySelectorAll('.hh-home-faqs-section').forEach(initAccordion);
    document.querySelectorAll('.hh-faqs-page').forEach((page) => {
      initAccordion(page);
      initFaqsPage();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
